import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { SystemAdminFormTypes } from 'helper/types';
import type { RootState } from 'store/reducers';

export interface SystemFleetState {
    name: string | undefined;
    selectedVehicles: string[] | undefined;
    selectedTeams: string[] | undefined;
    openForm: SystemAdminFormTypes | undefined;
}

const initialState: SystemFleetState = {
    name: undefined,
    selectedVehicles: undefined,
    selectedTeams: undefined,
    openForm: undefined,
};

export const systemFleetSlice = createSlice({
    name: 'systemFleets',
    initialState,
    reducers: {
        addSelectedVehicles: (state: SystemFleetState, action: PayloadAction<string[]>) => {
            state.selectedVehicles = state.selectedVehicles
                ? [...state.selectedVehicles, ...action.payload]
                : [...action.payload];
        },
        removeSelectedVehicle: (state: SystemFleetState, action: PayloadAction<string>) => {
            state.selectedVehicles = state.selectedVehicles
                ? state.selectedVehicles.filter(_ => _ !== action.payload)
                : [];
        },
        clearSelectedVehicles: (state: SystemFleetState) => {
            state.selectedVehicles = undefined;
        },
        addSelectedTeamsToFleetForm: (state: SystemFleetState, action: PayloadAction<string[]>) => {
            state.selectedTeams = [...action.payload];
        },
        removeSelectedTeam: (state: SystemFleetState, action: PayloadAction<string>) => {
            state.selectedTeams = state.selectedTeams ? state.selectedTeams.filter(_ => _ !== action.payload) : [];
        },
        clearSelectedTeams: (state: SystemFleetState) => {
            state.selectedTeams = undefined;
        },
        clearFleetFormData: (state: SystemFleetState) => {
            state.name = undefined;
            state.selectedTeams = undefined;
            state.selectedVehicles = undefined;
        },
        setFormFleetName: (state: SystemFleetState, action: PayloadAction<string | undefined>) => {
            state.name = action.payload;
        },
        setSystemFleetsFormType: (state: SystemFleetState, action: PayloadAction<SystemAdminFormTypes | undefined>) => {
            state.openForm = action.payload;
        },
    },
});

export const {
    addSelectedVehicles,
    removeSelectedVehicle,
    addSelectedTeamsToFleetForm,
    removeSelectedTeam,
    setFormFleetName,
    clearSelectedVehicles,
    clearFleetFormData,
    clearSelectedTeams,
    setSystemFleetsFormType,
} = systemFleetSlice.actions;

export const getNameFromFleetForm = (state: RootState) => state.systemFleet.name;
export const getSelectedVehiclesFromFleetForm = (state: RootState) => state.systemFleet.selectedVehicles;
export const getSelectedTeamsFromFleetForm = (state: RootState) => state.systemFleet.selectedTeams;
export const getSystemFleetsFormType = (state: RootState) => state.systemFleet.openForm;

export default systemFleetSlice.reducer;
